import { render, staticRenderFns } from "./addMaterialModal.vue?vue&type=template&id=a290d1b0&scoped=true&"
import script from "./addMaterialModal.vue?vue&type=script&lang=js&"
export * from "./addMaterialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a290d1b0",
  null
  
)

export default component.exports